import templateUrl from "emun.order/order-details-invoices.htm";

export default () => ({ templateUrl });
